// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import classnames from 'classnames'


import PropTypes from 'prop-types'


import 'styles/components/TabbedView.styl'

const TabbedView = React.createClass({
  propTypes: {
    tabs: PropTypes.array
  },

  getInitialState() { return {
    selectedTab: _.head(this.props.tabs)
  } },

  render() {
    return (
      <div className="TabbedView-wrapper">
        <div className="TabbedView">
          {_.map(this.props.tabs, tab => {
            return (
              <div
                key={tab.display}
                className={classnames('tab', { isSelected: this.state.selectedTab.display === tab.display })}
                onClick={this.tabClicked.bind(this, tab)}>
                {tab.display}
              </div>
            )
          })}
        </div>
        {this.state.selectedTab.render()}
      </div>
    )
  },

  tabClicked(tab) {
    return this.setState({ selectedTab: tab })
  }

})

export default TabbedView



// WEBPACK FOOTER //
// ./src/scripts/components/TabbedView.js